var chunkToChildrenMap = {
	"1268": [
		2412,
		5698
	],
	"2398": [
		2412,
		5698
	],
	"2412": [
		2412
	],
	"5249": [
		2412,
		5698
	],
	"9792": [
		2412,
		5698
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };